import * as React from 'react';
import { Panel, Alert, Spinner } from '@watcherr/ui';
import { t } from '~/i18n';
import { State } from '~/store/types';
import connect from '~/store/connect';
import AlertTable from '~/components/AlertTable';

interface ResidentAlertsContainerProps {
  loadAlerts: State['residentDetail']['loadAlerts'],
  alertsInProgress: State['residentDetail']['alertsInProgress'],
  previousAlerts: State['residentDetail']['previousAlerts'],
  loading: State['residentDetail']['loading'],
}

const ResidentAlertsContainer: React.FC<ResidentAlertsContainerProps> = ({
  loadAlerts,
  alertsInProgress,
  previousAlerts,
  loading,
}) => {
  React.useEffect(() => {
    loadAlerts();
  }, []);
  if (loading) {
    return <Spinner label={t('global.loading')} />;
  }

  return (
    <>
      <Panel.Section>
        <Panel.Title>{t('residentDetail.alerts.inProgress')}</Panel.Title>
        {alertsInProgress.length ? (
          <AlertTable alerts={alertsInProgress} />
        ) : (
          <Alert type="message">
            {t('residentDetail.alerts.nothingInProgress')}
          </Alert>
        )}
      </Panel.Section>
      <Panel.Section>
        <Panel.Title>{t('residentDetail.alerts.previousAlerts')}</Panel.Title>
        {previousAlerts.length ? (
          <AlertTable alerts={previousAlerts} />
        ) : (
          <Alert type="message">
            {t('residentDetail.alerts.noPreviousAlerts')}
          </Alert>
        )}
      </Panel.Section>
    </>
  );
};

export default connect((state: State) => ({
  loadAlerts: state.residentDetail.loadAlerts,
  alertsInProgress: state.residentDetail.alertsInProgress,
  previousAlerts: state.residentDetail.previousAlerts,
  loading: state.residentDetail.loading,
}))(ResidentAlertsContainer);
